// Field definitions
export const requiredFields = [
  { key: 'denomination', label: 'Denomination', required: true },
  { key: 'year', label: 'Year', required: true }
].sort((a, b) => a.label.localeCompare(b.label));

export const optionalFields = [
  { key: 'country', label: 'Country' },
  { key: 'cac_sticker', label: 'CAC Sticker' },
  { key: 'certification_number', label: 'Certification Number' },
  { key: 'composition', label: 'Composition (%)' },
  { key: 'current_pop_higher', label: 'Current Population Higher' },
  { key: 'current_population', label: 'Current Population' },
  { key: 'diameter', label: 'Diameter (mm)' },
  { key: 'die_variety', label: 'Die Variety' },
  { key: 'edge', label: 'Edge' },
  { key: 'grade', label: 'Grade' },
  { key: 'grading_cost', label: 'Grading Cost' },
  { key: 'metal', label: 'Metal' },
  { key: 'minor_variety', label: 'Minor Variety' },
  { key: 'mint_mark', label: 'Mint Mark' },
  { key: 'mintage', label: 'Mintage' },
  { key: 'notes', label: 'Notes' },
  { key: 'pcgs_number', label: 'PCGS Number' },
  { key: 'pop_higher_when_bought', label: 'Population Higher When Bought' },
  { key: 'population_when_bought', label: 'Population When Bought' },
  { key: 'price_guide_value', label: 'Price Guide Value' },
  { key: 'provenance', label: 'Provenance' },
  { key: 'reference_number', label: 'Ref. #' },
  { key: 'assayer', label: 'Assayer' },
  { key: 'purchase_date', label: 'Purchase Date' },
  { key: 'purchase_price', label: 'Purchase Price' },
  { key: 'list_price', label: 'List Price' },
  { key: 'shipping_cost', label: 'Shipping Cost' },
  { key: 'status', label: 'Status' },
  { key: 'storage_location', label: 'Storage Location' },
  { key: 'total_cost', label: 'Total Cost' },
  { key: 'user_coin_id', label: 'User Coin ID' },
  { key: 'variety', label: 'Variety' },
  { key: 'weight', label: 'Weight (g)' }
].sort((a, b) => a.label.localeCompare(b.label));

export const salesFields = [
  { key: 'transaction_date', label: 'Transaction Date', required: true },
  { key: 'price', label: 'Price', required: true },
  { key: 'client_id', label: 'Client ID' },
  { key: 'client_name', label: 'Client Name' },
  { key: 'client_email', label: 'Client Email' },
  { key: 'fees', label: 'Transaction Fees' },
  { key: 'notes', label: 'Transaction Notes' },
  { key: 'certification_number', label: 'Certification Number' },
  { key: 'user_coin_id', label: 'User Coin ID' }
];

// Field variations for matching
export const coinFieldVariations = {
  certification_number: ['cert number', 'cert', 'certification', 'cert #', 'certificate number'],
  year: ['year', 'era', 'year/era', 'gregorian year', 'western year', 'common year', 'date', 'other year', 'alternative year', 'non-gregorian year', 'special year'],
  purchase_price: ['price', 'cost', 'amount paid', 'purchase amount', 'my cost'],
  purchase_date: ['date purchased', 'bought on', 'date bought'],
  denomination: ['denom', 'face value', 'value'],
  mint_mark: ['mint', 'mm', 'mintmark'],
  composition: ['metal composition', 'metal content', 'composition %', 'metal %'],
  population_when_bought: ['pop when bought', 'original pop', 'initial population', 'initial pop', 'starting pop', 'starting population'],
  current_population: ['current pop', 'population', 'pop', 'pop now', 'current total pop'],
  current_pop_higher: ['pop higher', 'population higher', 'higher pop', 'higher population', 'current pop higher', 'higher grade pop'],
  pop_higher_when_bought: ['initial pop higher', 'original pop higher', 'starting pop higher', 'higher pop when bought'],
  pcgs_number: ['pcgs #', 'pcgs #r', 'pcgs cert', 'pcgs certification'],
  price_guide_value: ['guide value', 'book value', 'current value', 'curent value'],
  notes: ['comments', 'owners comments', 'remarks'],
  country: ['region', 'area', 'territory'],
  cac_sticker: ['sticker', 'cac', 'cac status'],
  weight: ['coin weight', 'wt', 'grams', 'g'],
  diameter: ['coin diameter', 'dia', 'size', 'mm'],
  edge: ['edge type', 'edge design', 'rim', 'edge description'],
  status: ['current status'],
  user_coin_id: ['inv id', 'inventory id', 'inv #', 'inventory #'],
  grading_cost: ['grading fees', 'grading fee'],
  shipping_cost: ['shipping fees', 'shipping fee', 'ship cost', 'shipping'],
  total_cost: ['total cog', 'total cost of goods', 'cog', 'cost of goods'],
  list_price: ['asking price', 'listed price', 'listing price', 'show price'],
  storage_location: ['location', 'stored at', 'storage', 'storage place', 'where stored'],
  reference_number: ['ref', 'ref #', 'reference', 'reference #', 'reference no', 'ref no'],
  assayer: ['assay', 'assayer mark', 'assayer signature', 'assayer name', 'assayer id']
};

export const salesFieldVariations = {
  price: ['sale price', 'selling price', 'sold price', 'sold for', 'final price', 'amount'],
  transaction_date: ['sold date', 'date sold', 'transaction date', 'sale completed', 'date'],
  user_coin_id: ['inv id', 'inventory id', 'inv #', 'inventory #', 'coin id'],
  client_id: ['customer id', 'buyer id'],
  client_name: ['customer name', 'buyer name', 'client', 'customer', 'buyer'],
  client_email: ['customer email', 'buyer email', 'email'],
  fees: ['transaction fees', 'sale fees', 'commission', 'fee'],
  notes: ['transaction notes', 'sale notes', 'comments', 'remarks']
};
